// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3vFJE","text":"SelectPayment_text__3kIcV","title":"SelectPayment_title__oKmrx","btn":"SelectPayment_btn__27-fK"};